import React, {useState, useEffect} from 'react'

const STORAGE_KEY = 'myList'

const readList = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') } catch(e) { return [] }
}

const writeList = (list) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)) } catch(e){}
}

export default function SaveButton({show, movie, person}){
    const [saved, setSaved] = useState(false)
    const item = movie 
        ? {type:'movie', id: movie.id, title: movie.title, poster_path: movie.poster_path, release_date: movie.release_date} 
        : person
        ? {type:'person', id: person.id, name: person.name, profile_path: person.profile_path, known_for_department: person.known_for_department}
        : {type:'tv', id: show.id, title: show.name, poster_path: show.poster_path, first_air_date: show.first_air_date}

    useEffect(()=>{
        const list = readList()
        const found = list.find(i=> i.type === item.type && i.id === item.id)
        setSaved(!!found)
    }, [item.id])

    const toggle = () => {
        const list = readList()
        if (saved) {
            const next = list.filter(i=> !(i.type === item.type && i.id === item.id))
            writeList(next)
            setSaved(false)
        } else {
            list.push(item)
            writeList(list)
            setSaved(true)
        }
    }

    return <button type="button" className="button" onClick={toggle} style={{padding: '10px'}}>{saved ? 'Saved' : 'Save'}</button>
}
